import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../features/auth';
import { useModal } from '../features/modal/ModalContext';

const TutorialFloatingButton = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { isMachineModalOpen } = useModal();
  const pathname = location.pathname;
  const isTutorialPage = pathname === '/tutorial';
  const isHomepage = pathname === '/' || pathname === '/home-ponpon2025';

  // Only show on homepage for signed-out users, never on tutorial/other pages
  // Hide when machine modal is open
  if (user || isTutorialPage || !isHomepage || isMachineModalOpen) {
    return null;
  }

  return (
    <Link
      to="/tutorial"
      className="tutorial-floating-button fixed top-[calc(var(--mobile-header-offset,3.25rem)+0.75rem)] right-4 z-50 flex items-center gap-1.5 rounded-full bg-ponpon-gold px-3 py-2 text-xs font-semibold text-white shadow-[0_6px_20px_rgba(246,195,78,0.3)] transition-all hover:-translate-y-1 hover:bg-[#E5B03D] hover:shadow-[0_8px_24px_rgba(246,195,78,0.4)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ponpon-gold/60 sm:top-auto sm:bottom-8 sm:right-8 sm:px-4 sm:py-2.5 sm:text-sm"
      aria-label="Learn how to play"
    >
      <span className="text-base leading-none sm:text-lg">📖</span>
      <span>How to Play</span>
    </Link>
  );
};

export default TutorialFloatingButton;
